import React from 'react';
import { Tag } from 'antd';

export type LangKey = 'zh' | 'en' | 'pl';

export const LANG_LIST: {
  key: LangKey;
  label: string;
  tagColor: string;
  accent: string;
  bg: string;
}[] = [
  { key: 'zh', label: '中文', tagColor: 'red', accent: '#ff4d4f', bg: '#fff1f0' },
  { key: 'en', label: 'English', tagColor: 'blue', accent: '#1890ff', bg: '#e6f7ff' },
  { key: 'pl', label: 'Polski', tagColor: 'gold', accent: '#faad14', bg: '#fffbe6' },
];

export const LangTag: React.FC<{ lang: (typeof LANG_LIST)[number] }> = ({ lang }) => (
  <Tag color={lang.tagColor} style={{ marginRight: 8, fontWeight: 500 }}>
    {lang.label}
  </Tag>
);

export const LangBlock: React.FC<{
  lang: (typeof LANG_LIST)[number];
  children: React.ReactNode;
}> = ({ lang, children }) => (
  <div
    data-i18n-ignore="true"
    style={{
      marginBottom: 16,
      padding: '12px 16px',
      borderRadius: 8,
      borderLeft: `4px solid ${lang.accent}`,
      background: lang.bg,
    }}
  >
    <div style={{ marginBottom: 10 }}>
      <LangTag lang={lang} />
    </div>
    {children}
  </div>
);

export const TextLine: React.FC<{ label: string; value?: string }> = ({ label, value }) => (
  <div style={{ marginBottom: 8, fontSize: 14 }}>
    <span style={{ color: '#666', marginRight: 8 }}>{label}:</span>
    <span style={{ color: value ? '#333' : '#bbb' }}>{value || '暂无'}</span>
  </div>
);
